import styled from '@emotion/styled';

import { PenLine } from '@features';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

export const MainTextStyled = styled.p`
  margin: 0;
  max-width: 770px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }

  ${getMediaqueryStyled('xl')} {
    max-width: 630px;
  }

  ${getMediaqueryStyled('lg')} {
    max-width: 415px;
  }

  ${getMediaqueryStyled('md')} {
    max-width: none;
  }
`;

export const TextPenUnderline = styled(PenLine)`
  ${getMediaqueryStyled('xl')} {
    width: 149px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 101px;
  }

  ${getMediaqueryStyled('md')} {
    width: 140px;
  }
`;

export const TextPenOutline = styled(PenLine)`
  ${getMediaqueryStyled('xl')} {
    width: 160px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 110px;
  }

  ${getMediaqueryStyled('md')} {
    width: 152px;
  }
`;
